module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalJobs', {
    attrs: {
      "abnormal-jobs-list": _vm.abnormalJobsList
    },
    on: {
      "refresh-list": _vm.getAbnormalJobs,
      "no-alarm": _vm.noAlarm
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777d1f67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/alarm_manage/alarm_abnormal_jobs.vue
// module id = 1425
// module chunks = 1